import React from "react";
import SidebarAdList from "./SidebarAdList";

/**
 * Sidebar — right column that stacks ALL active creatives from the `sidebar` slot.
 * Also renders any creatives from the `sidebar-bottom` slot below.
 * Renders nothing when there are no ads (no empty placeholders).
 */
export default function Sidebar({ category, articleId, className = "" }) {
  return (
    <aside className={`w-[300px] shrink-0 hidden lg:block ${className}`} data-testid="site-sidebar">
      <div className="sticky top-24 space-y-6">
        <SidebarAdList slot="sidebar" category={category} articleId={articleId} />
        <SidebarAdList slot="sidebar-bottom" category={category} articleId={articleId} />
      </div>
    </aside>
  );
}
